/*
 *
 * CapCollapsibleLeftNavigation reducer
 *
 */
import { fromJS } from 'immutable';
import * as types from './constants';

export const initialState = fromJS({
  navigationConfigLoading: types.IDLE,
  navigationConfig: [],
});

const navigationConfigReducer = (state = initialState, action={}) => {
  switch (action.type) {
    case types.GET_NAVIGATION_CONFIG_REQUEST:
      return state.set('navigationConfigLoading', types.REQUEST);
    case types.GET_NAVIGATION_CONFIG_SUCCESS:
      return state
        .set('navigationConfigLoading', types.COMPLETE)
        .set('navigationConfig', fromJS(action.data));
    case types.GET_NAVIGATION_CONFIG_FAILURE:
      return state
      .set('navigationConfigLoading', types.COMPLETE)
      .set("navigationConfig", fromJS([]));
    default:
      return state;
  }
};

export default navigationConfigReducer;
